import React from 'react'

import Section from 'component/Section'
import SectionHeader from 'component/SectionHeader'
import QuoteCard from 'component/QuoteCard'
import SmallSlider from 'component/Slider'

const SocialProof = () => {
	return (
		<Section theme="socialProof">
			<SectionHeader
				title="Depoimentos"
				titleHeadingSize="2"
				id="sectionHeaderDepoimentos"
			/>
			<SmallSlider
				theme={'homeQuotes desktop'}
				showPerSlide={1}
				infinite={true}
				adaptiveHeight={true}
				items={[
					{
						id: '1',
						content: (
							<QuoteCard
								text="Há mais de duas décadas trabalho com software desenvolvido por essa empresa e posso atestar que é de excelência."
								author="Luis Fernando Bueno"
							/>
						),
					},
					{
						id: '2',
						content: (
							<QuoteCard
								text="Eu não consigo ver o êxito do meu trabalho sem a gestão proporcionada pelo software de vocês! Obrigado pelo esforço de toda a sua equipe, tanto no atendimento quanto no aperfeiçoamento da ferramenta digital."
								author="William Pedrotti"
								company="Pedrotti Advocacia"
							/>
						),
					},
					{
						id: '3',
						content: (
							<QuoteCard
								text="Sou, talvez, um dos primeiros usuários do Astrea. A interface e a navegabilidade ainda continuam chamando a nossa atenção. Um sistema simples, mas completo. Depois de dois Aurum Summits, nós, da Amaral Advogados, podemos nos considerar quase Áureos. Sucesso sempre!"
								author="Heitor Amaral"
								company="Amaral Advogados"
							/>
						),
					},
					{
						id: '4',
						content: (
							<QuoteCard
								text="Gosto demais da atenção dispensada pelos consultores quando preciso e ainda estão em constante evolução. A Aurum está de parabéns!"
								author="Andressa Mello Ramos"
							/>
						),
					},
					{
						id: '5',
						content: (
							<QuoteCard
								text="Trabalho executado com a melhor qualidade, presteza, rapidez e clareza. Estou satisfeito."
								author="Marcio Medeiros"
							/>
						),
					},
				]}
			/>

			<SmallSlider
				theme={'homeQuotes mobile'}
				showPerSlide={1}
				infinite={true}
				adaptiveHeight={true}
				items={[
					{
						id: '1',
						content: (
							<QuoteCard
								text="Há mais de duas décadas trabalho com software desenvolvido por essa empresa e posso atestar que é de excelência."
								author="Luis Fernando Bueno"
							/>
						),
					},
					{
						id: '4',
						content: (
							<QuoteCard
								text="Gosto demais da atenção dispensada pelos consultores quando preciso e ainda estão em constante evolução. A Aurum está de parabéns!"
								author="Andressa Mello Ramos"
							/>
						),
					},
				]}
			/>
		</Section>
	)
}

export default SocialProof
